if (!customElements.get('sale-bar')) {
  customElements.define(
    'sale-bar',
    class SaleBar extends HTMLElement {
      constructor() {
        super();
        this.storageKey = 'kimbo-sale-bar-dismissed';
        this.sectionId = this.dataset.sectionId;
        this.isSticky = this.dataset.sticky === 'true';
        this.isDismissable = this.dataset.dismissable === 'true';
        this._updateOffset = this._updateOffset.bind(this);
      }

      connectedCallback() {
        if (this.isDismissable && this._isDismissed()) {
          this.classList.add('sale-bar--hidden');
          return;
        }

        if (this.isDismissable) {
          const closeBtn = this.querySelector('.sale-bar__close');
          if (closeBtn) {
            closeBtn.addEventListener('click', () => this._dismiss());
          }
        }

        if (this.isSticky) {
          this._initStickyOffset();
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        window.removeEventListener('resize', this._updateOffset);
      }

      _isDismissed() {
        try {
          return localStorage.getItem(this.storageKey) === this.sectionId;
        } catch (e) {
          return false;
        }
      }

      _dismiss() {
        this.classList.add('sale-bar--hidden');
        try {
          localStorage.setItem(this.storageKey, this.sectionId);
        } catch (e) {
          /* ignore quota / disabled storage */
        }
      }

      _initStickyOffset() {
        const header = document.querySelector('.section-header');
        if (!header) {
          this.style.setProperty('--sale-bar-offset', '0px');
          return;
        }

        this._updateOffset();

        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(this._updateOffset);
          this.resizeObserver.observe(header);
        }
        window.addEventListener('resize', this._updateOffset, { passive: true });
      }

      _updateOffset() {
        const header = document.querySelector('.section-header');
        if (!header) return;
        const height = header.getBoundingClientRect().height;
        this.style.setProperty('--sale-bar-offset', `${Math.round(height)}px`);
      }
    }
  );
}
